/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Running_PlanInputs */

const en_portal_goal_running_plan = /** @type {(inputs: Portal_Goal_Running_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervals, tempo runs and long runs`)
};

const pl_portal_goal_running_plan = /** @type {(inputs: Portal_Goal_Running_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interwały, tempo i długie wybieganie`)
};

/**
* | output |
* | --- |
* | "Intervals, tempo runs and long runs" |
*
* @param {Portal_Goal_Running_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_running_plan = /** @type {((inputs?: Portal_Goal_Running_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Running_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_running_plan(inputs)
	return en_portal_goal_running_plan(inputs)
});